<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <div>{{ titleKey | translate }}</div>
    <span
      class="ui-icon-close c-p"
      [class.disabled]="isCreatingPersonGroup()"
      (click)="onCancel()"
      tabindex="0"
      role="button"></span>
  </div>
  <div class="body">
    <div class="input-container flex-col">
      <label class="input-label">{{ 'PERSON_GROUPS.NAME_DIALOG.NAME_LABEL' | translate }}</label>
      <input
        class="ui-input ui-input-40 w-100"
        [formControl]="nameControl"
        [placeholder]="'PERSON_GROUPS.NAME_DIALOG.NAME_PLACEHOLDER' | translate"
        cdkFocusInitial
        uiAutofocus
      />
      @if (nameControl.hasError('required') && nameControl.touched) {
        <span class="input-error">{{ 'PERSON_GROUPS.NAME_DIALOG.ERROR_REQUIRED' | translate }}</span>
      }
      @if (nameControl.hasError('duplicate')) {
        <span class="input-error">{{ 'PERSON_GROUPS.NAME_DIALOG.ERROR_DUPLICATE' | translate: { name: duplicateName } }}</span>
      }
    </div>
  </div>
  <div class="footer flex-row end-center">
    <ui-button
      type="default"
      [text]="'COMMON.CANCEL' | translate"
      [disabled]="isCreatingPersonGroup()"
      (clickAction)="onCancel()"></ui-button>
    <ui-button
      type="primary"
      [text]="submitKey | translate"
      [loading]="isCreatingPersonGroup()"
      [disabled]="nameControl.invalid || !nameControl.value?.trim() || isCreatingPersonGroup()"
      (clickAction)="onContinue()"
    ></ui-button>
  </div>
</div>
